// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"fc27640c","44":"3b102c5b","220":"04c9d28d","221":"92723bfb","467":"3d1a0091","519":"ac3c3f83","559":"72159a61","583":"95ae48b7","615":"bf185b41","626":"993b84a9","733":"bbe655e3","871":"48943968","983":"dc7cb5d8"}[chunkId] + ".chunk.js";
};